import React from 'react';
import styled from 'styled-components';
import { Container, Typography, Button } from '../../components/atoms';
import { useTheme } from '../../contexts';
import { Link as RouterLink } from 'react-router-dom';

const NotFoundSection = styled.section`
  padding: 6rem 2rem;
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NotFoundContent = styled.div`
  text-align: center;
  max-width: 600px;
`;

const ErrorCode = styled.h1`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 8rem;
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  color: ${({ theme }) => theme.colors.primary.main};
  line-height: 1;
  margin-bottom: 1rem;
`;

const NotFound = () => {
  const { theme } = useTheme();

  return (
    <NotFoundSection>
      <NotFoundContent>
        <ErrorCode>404</ErrorCode>
        <Typography variant="h3" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <RouterLink to="/">
          <Button variant="primary">
            Go Home
          </Button>
        </RouterLink>
      </NotFoundContent>
    </NotFoundSection>
  );
};

export default NotFound;